import React, { useState, useEffect } from 'react';

/**
 * Shows a persistent banner when the app is offline.
 * Listens to the browser's online/offline events.
 */
const OfflineBanner = () => {
    const [isOnline, setIsOnline] = useState(
        typeof navigator !== 'undefined' ? navigator.onLine : true
    );

    useEffect(() => {
        const handleOnline = () => setIsOnline(true);
        const handleOffline = () => setIsOnline(false);

        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, []);

    if (isOnline) return null;

    return (
        <div
            role="alert"
            aria-live="polite"
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                zIndex: 9999,
                padding: '12px 16px',
                textAlign: 'center',
                backgroundColor: '#c53030',
                color: '#fff',
                fontFamily: 'sans-serif',
                fontSize: '14px',
                fontWeight: 600,
                boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
            }}
        >
            You are offline. Some features may be unavailable until your connection is restored.
        </div>
    );
};

export default OfflineBanner;
